import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import PremiumIcon from '@wix/da-ds/pkg/Icons/PremiumFolder';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import Flex from '@wix/da-ds/pkg/Flex';
import Heading from '../../a11y/headings/Heading';
import StatisticsBar from '../Helper/StatisticsBar';
import TierPriceWithBadge from '../Helper/TierPriceWithBadge';
import UserIdentity from '../../User/Identity';
import s from './TierSidebarCardInner.scss';
/** Inner content and styling for TierSidebarCard that accepts props instead of a deviation */
var TierSidebarCard = function (_a) {
    var user = _a.user, monthlyPrice = _a.monthlyPrice, imageSrc = _a.imageSrc, title = _a.title, _b = _a.subscriberCount, subscriberCount = _b === void 0 ? 0 : _b, description = _a.description, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement(Flex, { className: classnames(s['root'], className), direction: "column" },
        React.createElement(UserIdentity, { user: user, size: "small", className: s['identity'] }),
        imageSrc && React.createElement("img", { className: s['image'], src: imageSrc, alt: "" }),
        title && React.createElement(Heading, { className: s['title'] }, title),
        React.createElement(StatisticsBar, { className: s['statistics'], stats: [
                {
                    icon: PremiumIcon,
                    label: t('deviationview.tierCard.subscribers', {
                        count: subscriberCount,
                    }),
                },
            ] }),
        description && React.createElement("div", { className: s['description'] }, description),
        React.createElement("hr", { className: s['divider'] }),
        React.createElement(Flex, { alignItems: "center" },
            React.createElement(TierPriceWithBadge, { className: s['price'], price: monthlyPrice }),
            React.createElement(BrandedButton, { size: "medium", variant: "brand-green" }, t('deviationview.tierCard.cta.subscribe')))));
};
TierSidebarCard.displayName = 'TierSidebarCard';
export default TierSidebarCard;
//# sourceMappingURL=TierSidebarCardInner.js.map